const config = {
  API_URL:
  // process.env.PUBLIC_API_URL || "https://toptop.ecert365.com/btopuser",
  // process.env.PUBLIC_API_URL || "https://www.top-top.kr/btopuser",
  process.env.REACT_APP_PUBLIC_API_URL || '',
};

export default config;